import { Observable, of } from 'rxjs';
import { TemplateFunctionsModel } from 'src/app/shared/models/template-functions';
import {  IdsStepsTreatmentWizardModel } from 'src/app/shared/models/idsStepsTreatmentWizard.model';

export function templatePayMethodStepCheckShowActionButton({ flowwwerTemplate }: TemplateFunctionsModel): Observable<boolean> {
    return flowwwerTemplate();
}

export function templatePaymethodsActionButtonDisabled({ flowwwerTemplate }: TemplateFunctionsModel): Observable<boolean> {
    return flowwwerTemplate();
}

export function templatePaymethodUndoNextStep({ flowwwerTemplate }: TemplateFunctionsModel): Observable<boolean> {
    return flowwwerTemplate();
}

export function templateResultStepCheckShowActionButton({ flowwwerTemplate }: TemplateFunctionsModel): Observable<boolean> {
    return flowwwerTemplate();
}


const FAMILIES = IdsStepsTreatmentWizardModel.FAMILIES;
const PAYMETHODS = IdsStepsTreatmentWizardModel.PAYMETHODS;
const PAYMENT = IdsStepsTreatmentWizardModel.PAYMENT;
const RESULT = IdsStepsTreatmentWizardModel.RESULT;

export const stepsLabels = {
    FAMILIES: 'lbl_treatment_choose',
    PAYMETHODS: 'lbl_paymethod',
    PAYMENT: 'lbl_payment_complete',
    RESULT: 'lbl_treatment_result',
};